export function normalizeCheckoutPriorArRows(rows = []) {
  return (Array.isArray(rows) ? rows : [])
    .map((row) => {
      const id = row?.ar_receivable_id || row?.id;
      const outstanding = Number(
        row?.outstanding_centavos
        ?? row?.remaining_centavos
        ?? row?.amount_centavos
        ?? 0,
      );
      if (!id || !Number.isFinite(outstanding) || outstanding <= 0) return null;
      return {
        ...row,
        ar_receivable_id: id,
        ar_number: row?.ar_number || `AR-${String(id).replace(/-/g, "").slice(0, 8).toUpperCase()}`,
        outstanding_centavos: Math.round(outstanding),
      };
    })
    .filter(Boolean);
}

export function selectedPriorArTotalCentavos(rows = [], selected = {}) {
  return normalizeCheckoutPriorArRows(rows)
    .reduce((sum, row) => sum + priorArCollectionAmountCentavos(row, selected[row.ar_receivable_id]), 0);
}

export function priorArCollectionAmountCentavos(row, selection) {
  if (selection === true) return Number(row?.outstanding_centavos || 0);
  if (selection === false || selection == null) return 0;

  const amount = typeof selection === "object"
    ? Number(selection.amount_centavos ?? selection.collect_amount_centavos ?? 0)
    : Number(selection);
  if (!Number.isFinite(amount) || amount <= 0) return 0;
  return Math.round(amount);
}

export function buildCheckoutPriorArCollections({
  rows = [],
  selected = {},
  amountTenderedCents = 0,
  method = "cash",
  referenceNumber = "",
  proofUrl = "",
  appointmentId = "",
} = {}) {
  const normalized = normalizeCheckoutPriorArRows(rows)
    .map((row) => ({
      row,
      amount_centavos: priorArCollectionAmountCentavos(row, selected[row.ar_receivable_id]),
    }))
    .filter(({ amount_centavos }) => amount_centavos > 0);
  const overCollection = normalized.find(({ row, amount_centavos }) => amount_centavos > Number(row.outstanding_centavos || 0));
  if (overCollection) {
    return {
      error: `Selected prior AR collection ${overCollection.amount_centavos} centavos exceeds prior AR outstanding ${overCollection.row.outstanding_centavos} centavos.`,
      total_centavos: 0,
      collections: [],
    };
  }

  const total = normalized.reduce((sum, { amount_centavos }) => sum + amount_centavos, 0);
  const tendered = Number(amountTenderedCents || 0);
  if (total > 0 && tendered < total) {
    return {
      error: `Selected prior AR collection exceeds amount tendered. Selected ${total} centavos.`,
      total_centavos: total,
      collections: [],
    };
  }

  const cleanMethod = String(method || "cash").trim().toLowerCase() || "cash";
  const cleanReference = String(referenceNumber || "").trim();
  const cleanProofUrl = String(proofUrl || "").trim();
  const prefix = appointmentId ? `checkout:${appointmentId}` : "checkout";

  return {
    error: null,
    total_centavos: total,
    collections: normalized.map(({ row, amount_centavos }) => ({
      ar_receivable_id: row.ar_receivable_id,
      amount_centavos,
      method: cleanMethod,
      reference_number: cleanMethod === "cash" ? undefined : cleanReference,
      proof_url: cleanProofUrl || undefined,
      notes: "Collected during checkout from prior patient AR.",
      idempotency_key: `${prefix}:prior_ar:${row.ar_receivable_id}`,
    })),
  };
}
